

import React, { memo } from 'react';
import {
  DATA_TABLE_EXPANDER_WITH_DATA_COLUMN_OPTIONS } from
'../../../../../common/constants/column/dataTableColumnsOptions';
import DataTableBodyFullWidthRow from './DataTableBodyFullWidthRow';



const DataTableBodyExpanderWithDataRow = () =>
<DataTableBodyFullWidthRow
  column={DATA_TABLE_EXPANDER_WITH_DATA_COLUMN_OPTIONS}
  isExpander />;



export default memo(DataTableBodyExpanderWithDataRow);